export default "__VITE_ASSET__BLCdwbO7__"